export const optOutText = 'Text STOP for NO text.'
